import React from "react";
import { AlertTriangle, ArrowUpRight, X } from "lucide-react";

import { useEnvironment } from "@/context/EnvironmentContext";
import { DocumentReadinessNoticeData } from "@/utility/documentReadiness";

import "@/components/DialogPopup/DialogPopup.css";
import "@/components/DialogPopup/DialogPopupHeader/DialogPopupHeader.css";

interface DocumentReadinessModalProps {
  notice: DocumentReadinessNoticeData | null;
  onClose: () => void;
  projectId?: string | null;
  projectName?: string | null;
}

function DocumentReadinessModal({ notice, onClose, projectId, projectName }: DocumentReadinessModalProps) {
  const { selectedEnvironment } = useEnvironment();

  if (!notice) {
    return null;
  }

  const workspaceUrl = selectedEnvironment?.workspace_url;
  const projectDocumentsUrl =
    workspaceUrl && projectId ? `${workspaceUrl}/app-0001/documents?projectId=${encodeURIComponent(projectId)}` : null;

  return (
    <div className="dialog-popup-overlay">
      <div
        className="dialog-popup-container document-readiness-modal-container"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="document-readiness-modal-title"
      >
        <div className="dialog-popup-header">
          <div className="dialog-popup-icon document-readiness-modal-icon">
            <AlertTriangle size={22} aria-hidden="true" />
          </div>
          <div className="dialog-popup-title-group">
            <h2 id="document-readiness-modal-title" className="dialog-popup-title">
              Documents not ready
            </h2>
            <p className="dialog-popup-subtitle">{projectName || "Project Documents"}</p>
          </div>
          <button
            type="button"
            className="document-readiness-modal-close"
            onClick={onClose}
            aria-label="Close document readiness dialog"
          >
            <X size={16} aria-hidden="true" />
          </button>
        </div>

        <div className="dialog-popup-content">
          <div className="dialog-popup-section document-readiness-modal-body">
            <p className="document_readiness_message">{notice.message}</p>

            <a
              href={projectDocumentsUrl || undefined}
              target={projectDocumentsUrl ? "_blank" : undefined}
              rel={projectDocumentsUrl ? "noreferrer" : undefined}
              aria-disabled={!projectDocumentsUrl}
              className={`document_readiness_link ${projectDocumentsUrl ? "" : "disabled"}`}
              onClick={(event) => {
                if (!projectDocumentsUrl) {
                  event.preventDefault();
                }
              }}
            >
              <span>Open Project Documents</span>
              <ArrowUpRight size={14} aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocumentReadinessModal;
